export default {
    winzApiUrl: 'https://localhost:7041',
    clientId: 'f2d4fe5b-807b-4e53-8efb-d625e8b01c5f',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 3, // Default to Debug level
};